module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAyCAYAAAAayliMAAAAAXNSR0IArs4c6QAAAT9JREFUaAXt2F0KgkAQB/B1O4qvdZ6COktIZymo89SrR1FzMlFEw9352mAWxIL9+P/Gl2Gds2EVsApYBawC/1aB8zPfw0ORO6PYJGSPLnh969b442VXPkLWT+eKAkbhN98glXM4hJ+KuP7PhP8c5TOHKiJq8VrsQvjKZ/5UbMv72n3m5rEDOMMDiBXAHZ4VIBGeDSAVngUgGZ4cIB2eFKARngygFZ4EoBkeDdAOjwKkED4akEp4AER1o0sdZN24BjaVHNG9UPHKD3VTX9uwfW8PudH9fSg+GgAHpYBAAVJAoAHaCBKAJoIMoIUgBWggyAHSCBaAJIINIIVgBUgg2AHcCBEAJyKqG4VAoQOuEOEqsV3XNnzDWOpshxm/f4l9gT7GqAF0FHej/b6ib0DAI3qoHWYVsApYBawCVoEUK/AGCUD2YH0PqWIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/navigation-left@2x.png
// module id = xs8x
// module chunks = 1